export const getExamineePhoto = ({
  photoExempt,
  url,
}: {
  photoExempt?: boolean;
  url?: string;
}): string => {
  if (photoExempt) {
    return '/static/img/avatar-examinee-exempt.png';
  }

  return url || '/static/img/avatar-examinee-default.png';
};

export default getExamineePhoto;
